import { MealOfDayHeuristicsWeights, RecommenderSettings } from '@/api/types'
import React from 'react'
import { HeuristicSlider } from './HeuristicSlider'
import { Label } from '@/components/Label'

type Props = {
  recommenderSettings: RecommenderSettings
  setRecommenderSettings: (settings: RecommenderSettings) => void
} & React.HTMLAttributes<HTMLDivElement>

export function MealDivisionHeuristics({
  recommenderSettings,
  setRecommenderSettings,
  ...props
}: Props) {
  function setHeuristicWeight(key: keyof MealOfDayHeuristicsWeights, value: number) {
    setRecommenderSettings({
      ...recommenderSettings,
      mealOfDayHeuristicsWeights: {
        ...recommenderSettings.mealOfDayHeuristicsWeights,
        [key]: value,
      },
    })
  }

  return (
    <div {...props}>
      <h3>Meal Division heuristics</h3>
      <HeuristicSlider
        label="ENERGY_SUITABILITY"
        value={recommenderSettings.mealOfDayHeuristicsWeights.ENERGY_SUITABILITY}
        onChange={(value) => {
          setHeuristicWeight('ENERGY_SUITABILITY', value)
        }}
      />
      <HeuristicSlider
        label="CARBOHYDRATE_SUITABILITY"
        value={recommenderSettings.mealOfDayHeuristicsWeights.CARBOHYDRATE_SUITABILITY}
        onChange={(value) => {
          setHeuristicWeight('CARBOHYDRATE_SUITABILITY', value)
        }}
      />
      <HeuristicSlider
        label="PROTEIN_SUITABILITY"
        value={recommenderSettings.mealOfDayHeuristicsWeights.PROTEIN_SUITABILITY}
        onChange={(value) => {
          setHeuristicWeight('PROTEIN_SUITABILITY', value)
        }}
      />
      <HeuristicSlider
        label="FAT_SUITABILITY"
        value={recommenderSettings.mealOfDayHeuristicsWeights.FAT_SUITABILITY}
        onChange={(value) => {
          setHeuristicWeight('FAT_SUITABILITY', value)
        }}
      />
      <HeuristicSlider
        label="INGREDIENT_VARIETY"
        value={recommenderSettings.mealOfDayHeuristicsWeights.INGREDIENT_VARIETY}
        onChange={(value) => {
          setHeuristicWeight('INGREDIENT_VARIETY', value)
        }}
      />
      <HeuristicSlider
        label="VARIETY_OPTIONS"
        value={recommenderSettings.mealOfDayHeuristicsWeights.VARIETY_OPTIONS}
        onChange={(value) => {
          setHeuristicWeight('VARIETY_OPTIONS', value)
        }}
      />
      <HeuristicSlider
        label="LIMIT_MAIN_DISH_RECIPE_REPETITION"
        value={recommenderSettings.mealOfDayHeuristicsWeights.LIMIT_MAIN_DISH_RECIPE_REPETITION}
        onChange={(value) => {
          setHeuristicWeight('LIMIT_MAIN_DISH_RECIPE_REPETITION', value)
        }}
      />
      <HeuristicSlider
        label="MEAT_FISH_SEPARATION"
        value={recommenderSettings.mealOfDayHeuristicsWeights.MEAT_FISH_SEPARATION}
        onChange={(value) => {
          setHeuristicWeight('MEAT_FISH_SEPARATION', value)
        }}
      />
      <HeuristicSlider
        label="MINIMIZE_PRODUCT_CATEGORIES"
        value={recommenderSettings.mealOfDayHeuristicsWeights.MINIMIZE_PRODUCT_CATEGORIES}
        onChange={(value) => {
          setHeuristicWeight('MINIMIZE_PRODUCT_CATEGORIES', value)
        }}
      />
      <HeuristicSlider
        label="LITRE_OF_SOUP_IN_A_ROW"
        value={recommenderSettings.mealOfDayHeuristicsWeights.LITRE_OF_SOUP_IN_A_ROW}
        onChange={(value) => {
          setHeuristicWeight('LITRE_OF_SOUP_IN_A_ROW', value)
        }}
      />
      <HeuristicSlider
        label="USER_PREFERENCES"
        value={recommenderSettings.mealOfDayHeuristicsWeights.USER_PREFERENCES}
        onChange={(value) => {
          setHeuristicWeight('USER_PREFERENCES', value)
        }}
      />
      <HeuristicSlider
        label="SEASON"
        value={recommenderSettings.mealOfDayHeuristicsWeights.SEASON}
        onChange={(value) => {
          setHeuristicWeight('SEASON', value)
        }}
      />
      <HeuristicSlider
        label="NO_COMFORT_FOOD"
        value={recommenderSettings.mealOfDayHeuristicsWeights.NO_COMFORT_FOOD}
        onChange={(value) => {
          setHeuristicWeight('NO_COMFORT_FOOD', value)
        }}
      />
      <HeuristicSlider
        label="COMMON_FRUIT"
        value={recommenderSettings.mealOfDayHeuristicsWeights.COMMON_FRUIT}
        onChange={(value) => {
          setHeuristicWeight('COMMON_FRUIT', value)
        }}
      />
      <HeuristicSlider
        label="CHEAPER_FOOD"
        isDisabled={true}
        value={recommenderSettings.mealOfDayHeuristicsWeights.CHEAPER_FOOD}
        onChange={(value) => {
          setHeuristicWeight('CHEAPER_FOOD', value)
        }}
      />
      <HeuristicSlider
        label="DIABETES"
        isDisabled={true}
        value={recommenderSettings.mealOfDayHeuristicsWeights.DIABETES}
        onChange={(value) => {
          setHeuristicWeight('DIABETES', value)
        }}
      />
      <HeuristicSlider
        label="LOW_SUGAR_DRINKS"
        value={recommenderSettings.mealOfDayHeuristicsWeights.LOW_SUGAR_DRINKS}
        onChange={(value) => {
          setHeuristicWeight('LOW_SUGAR_DRINKS', value)
        }}
      />
    </div>
  )
}
